gsap.registerPlugin(ScrollTrigger);

const mm = gsap.matchMedia();
let lenis;

if (window.location.hash) {
	window.location.hash = "";
	window.scrollTo(0, 0);
}

function initLenis() {
	lenis = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		direction: "vertical",
		gestureDirection: "vertical",
		smooth: true,
		mouseMultiplier: 1,
		smoothTouch: false,
		touchMultiplier: 2,
		infinite: false,
	});

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}
	requestAnimationFrame(raf);

	document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			const href = this.getAttribute("href");
			const hash = new URL(href, window.location.href).hash;

			if (!hash) return;
			const target = document.querySelector(hash);

			if (target) {
				e.preventDefault();

				let offset = -90;

				lenis.scrollTo(target, {
					offset: offset,
					duration: 1.2,
					ease: "easeOutExpo",
				});
			}
		});
	});
}

const setVH = () =>
	document.documentElement.style.setProperty(
		"--vh",
		window.innerHeight * 0.01 + "px"
	);

function mobileMenuLogic() {
	const mobileMenu = document.getElementById("mobile-menu");
	const burger = document.getElementById("burger");
	const mobileLinks = document.querySelectorAll(".mobile-menu a");

	if (mobileLinks.length) {
		mobileLinks.forEach((l) => {
			l.addEventListener("click", () => {
				if (l.classList.contains("mobile-menu-opener")) return;
				burger.classList.remove("opened");
				mobileMenu.classList.remove("active");
				document.body.classList.remove("fixed");
			});
		});
	}

	burger?.addEventListener("click", () => {
		burger.classList.toggle("opened");
		mobileMenu.classList.toggle("active");
		document.body.classList.toggle("fixed");
	});
}

function homePageSwiper() {
	const section = document.querySelector(".main-hero");
	if (!section) return;

	const slider = section.querySelector(".heroSwiper");
	const btnPrev = section.querySelector(".slide-btn--prev");
	const btnNext = section.querySelector(".slide-btn--next");
	const pagination = section.querySelector(".swiper-pagination");

	return new Swiper(slider, {
		effect: "fade",
		loop: true,
		// fadeEffect: {
		// 	crossFade: true,
		// },
		slidesPerView: 1,
		pagination: {
			el: pagination,
		},
		navigation: {
			nextEl: btnNext,
			prevEl: btnPrev,
		},
	});
}

function mobileMenuLogic() {
	const mobileMenu = document.querySelector(".mobile-menu");
	const burger = document.getElementById("burger");
	const mobileLinks = document.querySelectorAll(".mobile-menu a");

	// if (mobileLinks.length) {
	// 	mobileLinks.forEach((l) => {
	// 		l.addEventListener("click", () => {
	// 			if (l.classList.contains("mobile-menu-opener")) return;
	// 			burger.classList.remove("opened");
	// 			mobileMenu.classList.remove("active");
	// 			document.body.classList.remove("fixed");
	// 		});
	// 	});
	// }

	burger?.addEventListener("click", () => {
		burger.classList.toggle("opened");
		mobileMenu.classList.toggle("active");
		document.body.classList.toggle("fixed");
	});

	const subMenuOpener = document.querySelector(".mobile-menu__opener");
	if (subMenuOpener)
		subMenuOpener.addEventListener("click", (e) =>
			subMenuOpener.classList.toggle("active")
		);
}

function megaMenu() {
	const header = document.querySelector(".header");
	const btn = document.getElementById("mega-menu-opener");
	const overlay = document.querySelector(".mega-menu__overlay");

	btn.addEventListener("click", (e) => {
		e.preventDefault();
		openMenu();
	});
	overlay.addEventListener("click", () => {
		removeMenu();
	});

	const openMenu = () => header.classList.toggle("mega-menu--opened");
	const removeMenu = () => header.classList.remove("mega-menu--opened");
}

function homePageSliders() {
	const sections = document.querySelectorAll(".mk-slider-block");

	if (!sections.length) return;

	sections.forEach((section) => {
		const slider = section.querySelector(".sliderBlockSwiper");
		const navNext = section.querySelector(".slide-btn--next");
		const navPrev = section.querySelector(".slide-btn--prev");
		return new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: {
				nextEl: navNext,
				prevEl: navPrev,
			},
			breakpoints: {
				1064: {
					slidesPerView: 4,
				},
				601: {
					slidesPerView: 2,
				},
			},
		});
	});
}

function homeBlogsSlider() {
	const section = document.querySelector(".home-blogs");

	if (!section) return;

	const slider = section.querySelector(".homeBlogSlider");
	const navNext = section.querySelector(".sliders-nav .slide-btn--next");
	const navPrev = section.querySelector(".sliders-nav .slide-btn--prev");

	return new Swiper(slider, {
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: navNext,
			prevEl: navPrev,
		},
		breakpoints: {
			1064: {
				slidesPerView: 3,
			},
			601: {
				slidesPerView: 2,
			},
		},
	});
}

function processScrollAnimation() {
	const block = document.querySelector(".process-list");
	if (!block) return;

	const items = [...block.querySelectorAll(".process-item")];
	const imgs = [...document.querySelectorAll(".process-img")];
	const line = block.querySelector(".process-line__inner");

	ScrollTrigger.create({
		trigger: block,
		start: "top 80%",
		end: "top 5%",
		scrub: true,
		// markers: true,

		onUpdate(self) {
			const progress = self.progress;

			gsap.set(line, {
				scaleY: progress,
			});

			const activeIndex = Math.min(
				items.length - 1,
				Math.floor(progress * items.length)
			);

			items.forEach((item, index) => {
				item.classList.toggle("active", index <= activeIndex);
			});
			imgs.forEach((item, index) => {
				item.classList.toggle("active", index <= activeIndex);
			});
		},
	});
}

function faqFunc() {
	const faqs = document.querySelectorAll(".faq");
	if (!faqs.length) return;

	let activeIndex = 0;

	faqs[activeIndex].classList.add("active");

	faqs.forEach((faq, ind) => {
		faq.addEventListener("click", () => {
			if (ind === activeIndex) return;

			faqs[activeIndex].classList.remove("active");
			activeIndex = ind;
			faqs[activeIndex].classList.add("active");
		});
	});
}

function technoHoverBlock() {
	const list = document.querySelectorAll(".techno__item");
	if (!list.length) return;

	let activeIndex = 0;

	list[activeIndex].classList.add("active");

	list.forEach((item, ind) => {
		item.addEventListener("mouseenter", () => {
			if (ind === activeIndex) return;

			list[activeIndex].classList.remove("active");
			activeIndex = ind;
			list[activeIndex].classList.add("active");
		});
	});
}

function sliderProgram() {
	const slider = document.querySelector(".my-slider");	
	if (!slider) return;
	console.log("slider inited");

	const photos = JSON.parse(slider.getAttribute("data-photos"));
	const titles = JSON.parse(slider.getAttribute("data-titles"));
	const texts = JSON.parse(slider.getAttribute("data-texts"));

	const generateDataArr = (arr, ind) => {
		const head = arr.slice(ind);
		const tail = arr.slice(0, ind);
		return [...head, ...tail];
	};

	const cards = slider.querySelectorAll(".slider-card");
	cards.forEach((el, ind) => {
		const photosArr = generateDataArr(photos, ind);
		const titlesArr = generateDataArr(titles, ind);
		const textsArr = generateDataArr(texts, ind);

		const imgPlaceholder = el.querySelector(".slider-card__img");
		const titlePlaceholder = el.querySelector(".slider-card__title");
		const textPlaceholder = el.querySelector(".slider-card__text");

		photosArr.forEach((i, ind) => {
			const img = document.createElement("img");
			img.setAttribute("src", i);

			const title = document.createElement("h3");
			title.textContent = titlesArr[ind];

			const text = document.createElement("p");
			text.textContent = textsArr[ind];

			imgPlaceholder.appendChild(img);
			titlePlaceholder.appendChild(title);
			textPlaceholder.appendChild(text);
		});
	});

	const startIndex = 0;
	const lastIndex = photos.length - 1;

	let activeIndex = startIndex;

	const btnPrev = slider.querySelector(".mk-slider-nav .slide-btn--prev");
	const btnNext = slider.querySelector(".mk-slider-nav .slide-btn--next");

	function renderData(index) {
		cards.forEach((card) => {
			const imgs = card.querySelectorAll(".slider-card__img img");
			const titles = card.querySelectorAll(".slider-card__title h3");
			const texts = card.querySelectorAll(".slider-card__text p");

			imgs.forEach((img) => img.classList.remove("active"));
			titles.forEach((t) => t.classList.remove("active"));
			texts.forEach((t) => t.classList.remove("active"));

			if (imgs[index]) {
				imgs[index].classList.add("active");
			}
			if (titles[index]) {
				titles[index].classList.add("active");
			}
			if (texts[index]) {
				texts[index].classList.add("active");
			}
		});
	}

	function toggleCards(newIndex) {
		activeIndex = newIndex;

		renderData(activeIndex);
		updateButtons();
	}

	function updateButtons() {
		btnPrev.classList.toggle("slider-btn--disabled", activeIndex === 0);

		btnNext.classList.toggle(
			"slider-btn--disabled",
			activeIndex === lastIndex
		);
	}

	renderData(activeIndex);
	updateButtons();

	btnNext.addEventListener("click", () => {
		if (activeIndex < lastIndex) {
			toggleCards(activeIndex + 1);
		}
	});

	btnPrev.addEventListener("click", () => {
		if (activeIndex > 0) {
			toggleCards(activeIndex - 1);
		}
	});

	// swiper for mobile
	const sliderMob = slider.querySelector(".mobile-Swiper");
	const navNext = slider.querySelector(".mk-slider-nav2 .slide-btn--next");
	const navPrev = slider.querySelector(".mk-slider-nav2 .slide-btn--prev");

	const sw = new Swiper(sliderMob, {
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: navNext,
			prevEl: navPrev,
		},
		breakpoints: {
			1064: {
				slidesPerView: 3,
			},
			601: {
				slidesPerView: 2,
			},
		},
	});
}

function customGallery() {
	const gallery = document.querySelector(".mk-custom-gallery");
	if (!gallery) return;

	const navNext = gallery.querySelector(".slide-btn--next");
	const navPrev = gallery.querySelector(".slide-btn--prev");

	const s2 = new Swiper(".mkGalleryThumbsSwiper", {
		slidesPerView: "auto",
		centeredSlider: true,
		freeMode: true,
		watchSlidesProgress: true, 
		spaceBetween: 20,
	});

	const s = new Swiper(".mkGallerySwiper", {
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: navNext,
			prevEl: navPrev,
		},
		thumbs: { swiper: s2 }, 
	});

	const variantSelects = document.querySelector("variant-selects");
	if (!variantSelects) return;
	const heroImg = document.getElementById("firstGalleryPhoto");
	const thumbsImg = document.getElementById("secondGalleryPhoto");

	subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
		const variant = event.data.variant;
		console.log("Chosed variant", variant);

		const src = variant?.featured_image.src;
		if (heroImg && src) {
			heroImg.src = src;
			thumbsImg.src = src;
		}

		s?.slideTo(0, 0);
	});
}

function blogTableOfContents() {
	const article = document.querySelector(".mk-custom-blog");
	if (!article) return;

	const content = document.querySelector(".article-content-js");
	const table = document.querySelector(".table_of_contents");

	if (!content || !table) {
		return;
	}

	const headings = content.querySelectorAll("h2, h3, h4, h5, h6");

	if (!headings.length) return;

	headings.forEach((heading, index) => {
		heading.id || (heading.id = `heading-${index}`);

		const link = document.createElement("a");
		(link.href = `#${heading.id}`),
			(link.textContent = heading.innerText.trim()),
			table.appendChild(link);
	});

	const tableBtn = document.querySelector(".custom-blog__table__top");

	tableBtn.addEventListener("click", () => {
		tableBtn.classList.toggle("active");
	});
}

function doubleSliders() {
	const sections = document.querySelectorAll(".double-slider__wrap");

	if (!sections.length) return;

	sections.forEach((section) => {
		const slider = section.querySelector(".doubleSlider");
		const navNext = section.querySelector(".slide-btn--next");
		const navPrev = section.querySelector(".slide-btn--prev");
		return new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: {
				nextEl: navNext,
				prevEl: navPrev,
			},
			breakpoints: {
				601: {
					slidesPerView: 2,
				},
			},
		});
	});
}

function productTabs() {
	const tabs = document.querySelector(".product-tabs");
	if (!tabs) return;
	const els = tabs.querySelectorAll(".product-tab");
	// let ind = null;
	// els[ind].classList.add("active");
	els?.forEach((el, i) => {
		const btn = el.querySelector(".product-tab__top");
		btn.addEventListener("click", () => {
			// if (ind !== null) {
			// 	els[ind].classList.remove("active");
			// }
			// ind = i;
			els[i].classList.toggle("active");
		});
	});
}

function animations() {
	ScrollTrigger.getAll().forEach((t) => t.kill());

	// document.body.classList.add('body--loaded');

	const titles = gsap.utils.toArray(".animated-title");
	if (titles.length) {
		titles.forEach((t) => {
			gsap.from(t, {
				x: 30,
				opacity: 0,
				ease: "power2",
				scrollTrigger: {
					trigger: t,
					start: "top 80%",
					toggleActions: "play none none reverse",
				},
			});
		});
	}

	// categories on main
	const cm = document.querySelector('.categories-main__cards');
	if (cm) {
		defaultCardsReveal(cm, ".categories-main__card", "top 80%", 0.125);
	}

	// sliders
	// const sliders = document.querySelectorAll('.mk-slider-block');
	// if (sliders.length) {
	// 	sliders.forEach(s => {
	// 		const block = s.querySelector('.mk-slider-block__self');
	// 		gsap.from(block, {
	// 			y: 30,
	// 			opacity: 0,
	// 			duration: 0.45,
	// 			ease: "sine.out",
	// 			scrollTrigger: {
	// 				trigger: s,
	// 				start: 'top 80%',
	// 			},
	// 		});
	// 	});
	// }

	// home blogs
	const hbs = document.querySelector('.home-blogs');
	if (hbs) {
		const block = hbs.querySelector('.home-blogs__wrap');
		gsap.from(block, {
			y: 30,
			opacity: 0,
			duration: 0.45,
			ease: "sine.out",
			scrollTrigger: {
				trigger: hbs,
				start: 'top 80%',
			},
		});
	}

	// faqs
	const faq = document.querySelector('.faq-list');
	if (faq) {
		defaultCardsReveal(faq, ".faq", "top 80%", 0.125);
	}

	// techno list
	const tb1 = document.querySelector('.techno__block');
	if (tb1) {
		defaultCardsReveal(tb1, ".techno__item", "top 80%", 0.125);
	}

	processScrollAnimation();
}

function defaultCardsReveal(wrapper, cardsClass, start, stagger = 0.2) {
	const cards = wrapper.querySelectorAll(cardsClass);
	gsap.from(cards, {
		y: 30,
		opacity: 0,
		duration: 0.45,
		stagger: stagger,
		ease: "sine.out",
		scrollTrigger: {
			trigger: wrapper,
			start: start,
			// markers: true,
		},
	});
}

function initScripts() {
	initLenis();
	setVH();
	homePageSliders();
	homeBlogsSlider();
	megaMenu();
	faqFunc();
	technoHoverBlock();
	sliderProgram();
	mobileMenuLogic();
	customGallery();
	blogTableOfContents();
	doubleSliders();
	productTabs();
}

window.addEventListener("DOMContentLoaded", () => {
	initScripts();
	setTimeout(() => {
		animations();
		homePageSwiper();
	}, 200);
});
